import { LinearProgress } from '@mui/material';
import styles from './MetricsViewer.module.css';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const MetricsViewer = ({ isOwnShop = true, shopId }) => {
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);
  const { t } = useTranslation();
  const [metricsData, setMetricsData] = useState({ groupCount: 0, groupLimit: 0, productCount: 0, productLimit: 0 });

  useEffect(() => {
    if (isOwnShop && user?.ownedShops) {
      setMetricsData({
        groupCount: user.ownedShops[0]?.metrics.groupCount,
        groupLimit: shopTier?.galleryLimit,
        productCount: user.ownedShops[0]?.metrics.productCount,
        productLimit: shopTier?.productsLimit
      });
    } else if (user?.maintainedShops && shopId) {
      setMetricsData({
        groupCount: user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.shop?.metrics?.groupCount,
        groupLimit: user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.shop?.shopTier?.galleryLimit,
        productCount: user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.shop?.metrics?.productCount,
        productLimit: user?.maintainedShops?.find((shop) => shop.shop.id === shopId)?.shop?.shopTier?.productsLimit
      });
    }
  }, [isOwnShop, user, shopId, shopTier]);

  return (
    <div className={styles.mainContainer}>
      <p
        style={{
          fontSize: 14,
          marginBottom: 0,
          color: metricsData.groupCount <= metricsData.groupLimit ? 'black' : 'var(--primary-error)',
          textWrap: 'wrap'
        }}>
        {t('metricsViewer.gallery')} {metricsData.groupCount}/{metricsData.groupLimit}
      </p>
      <LinearProgress
        variant='determinate'
        value={
          metricsData.groupCount <= metricsData.groupLimit
            ? (metricsData.groupCount / metricsData.groupLimit) * 100
            : 100
        }
        valueBuffer={40}
        sx={{
          height: 8,
          borderRadius: 5,
          backgroundColor: 'var(--primary-background-primary)',
          '& .MuiLinearProgress-bar': {
            backgroundColor:
              metricsData.groupCount <= metricsData.groupLimit
                ? 'var(--primary-background-secondary)'
                : 'var(--primary-error)'
          }
        }}
      />
      <p
        style={{
          fontSize: 14,
          marginBottom: 0,
          color: metricsData.productCount <= metricsData.productLimit ? 'black' : 'var(--primary-error)',
          textWrap: 'wrap'
        }}>
        {t('metricsViewer.product')} {metricsData.productCount}/{metricsData.productLimit}
      </p>
      <LinearProgress
        variant='determinate'
        value={
          metricsData.productCount <= metricsData.productLimit
            ? (metricsData.productCount / metricsData.productLimit) * 100
            : 100
        }
        valueBuffer={40}
        sx={{
          height: 8,
          borderRadius: 5,
          backgroundColor: 'var(--primary-background-primary)',
          '& .MuiLinearProgress-bar': {
            backgroundColor:
              metricsData.productCount <= metricsData.productLimit
                ? 'var(--primary-background-secondary)'
                : 'var(--primary-error)'
          }
        }}
      />
    </div>
  );
};

export default MetricsViewer;
